import { PlayCircleFilledWhite } from '@material-ui/icons';
import React, { Component } from 'react';
import Icon from "../../Assets/Icons/ART_Icon_Download";
import { Link } from "react-router-dom";
import Img221104 from "../../Assets/Novedades/FFEP_221104.jpg"
import Img221125 from "../../Assets/Novedades/FFEP_221125.jpg"
import Img221228 from "../../Assets/Novedades/FFEP_221228.jpg"
import Img230127 from "../../Assets/Novedades/FFEP_230127.jpg"
import Img230224 from "../../Assets/Novedades/FFEP_230224.jpg"
import Img230316 from "../../Assets/Novedades/FFEP_230316.jpg"
import Img230502 from "../../Assets/Novedades/FFEP_230502.jpg"
import Img230516 from "../../Assets/Novedades/FFEP_230516.jpg"
import Img230622 from "../../Assets/Novedades/FFEP_230622.jpg"
import Img230724 from "../../Assets/Novedades/FFEP_230724.jpg"
import Img230815 from "../../Assets/Novedades/FFEP_230815.jpg"
import Img230920 from "../../Assets/Novedades/FFEP_230920.jpg"
export class FFEP extends Component {
    render() {
        return (

            <div style={{ padding: '3% 6%' }} >

                <h2 className="inicio-title">ACTUALIZACIONES FFEP</h2><p /> <p />

                <div style={{ padding: '6% 0% 12% 0%', borderBottom: '3px solid #F8A700' }}>
                    <h5 style={{ color: 'white', backgroundColor: '#F8A700', width: 'fit-content' }}>
                        20 Septiembre 2023
                    </h5>

                    <h5 style={{ color: 'white', backgroundColor: '#F8A700' }}>
                        ACTUALIZACIÓN DEL FONDO FIDUCIARIO DE ENFERMEDADES PROFESIONALES (FFEP)<br />
                    </h5><p />
                    <br />
                    <p />

                    <p>
                        Le informamos que conforme lo establecido por la Resolución MTEYSS 649/2022 Disposición SRT 9/2023 a
                        partir del 01/10/2023, período AFIP a declarar 09/2023, el nuevo valor del FFEP será de $323.00.-
                        (TRESCIENTOS VENTITRÉS), por cada trabajador conjuntamente con la alícuota vigente de su contrato de Riesgos del Trabajo.
                    </p><p />
                    <p>La Resolución MTEYSS 649/2022 dispone que el valor de la suma fija en concepto de FFEP se incrementará mensualmente
                        para contratos del régimen general, según la variación de la remuneración imponible promedio de
                        las personas trabajadoras estables (ripte) - índice no decreciente- y también dispone que el Artículo 2° de
                        la Resolución MTEYSS N° 467, del 10 de agosto de 2021, será de aplicación exclusivamente para empleadores/as
                        de régimen especial de casas particulares donde será de $278,00.- en los periodos del 07/2023 al 09/2023 bajo la
                        <strong>Disposición 7/2023 SRT</strong>, siguiendo con el criterio de actualización mensual y/o trimestral.

                        <p />
                        Sin más saludamos a Ud. atentamente, quedando a disposición para cualquier consulta o inquietud.
                    </p>
                    <p />

                    <div>
                        <strong>Pasos a seguir para modificar la suma fija FFEP dentro del F931 – AFIP</strong>
                        <ul>
                            <li>Ingresar a AFIP con CUIT y Clave fiscal.</li>
                            <li> <strong>Servicio:</strong> Declaración en Línea.</li>
                        </ul>
                        <div style={{ 'text-align-last': 'center', zoom: '80%' }}>
                            <p>
                                <img src={Img230920} />
                            </p>
                        </div>
                    </div>

                    <p /><p /><p /><p /><p />
                </div>

                {/*------------------------------------------*/}

                <div style={{ padding: '6% 0% 12% 0%', borderBottom: '3px solid #F8A700' }}>
                    <h5 style={{ color: 'white', backgroundColor: '#F8A700', width: 'fit-content' }}>
                        15 Agosto 2023
                    </h5>

                    <h5 style={{ color: 'white', backgroundColor: '#F8A700' }}>
                        ACTUALIZACIÓN DEL FONDO FIDUCIARIO DE ENFERMEDADES PROFESIONALES (FFEP)<br />
                    </h5><p />
                    <br />
                    <p />

                    <p>

                        Le informamos que conforme lo establecido por la Resolución MTEYSS 6 9/2022 Disposición
                        SRT 08/2023 a partir del 01/08/2023, período AFIP a declarar 8/2023, el nuevo valor del
                        FFEP será de $301.00.- (TRESCIENTOS UNO),
                        por cada trabajador conjuntamente con la alícuota vigente de su contrato de Riesgos del
                        Trabajo.



                    </p><p />
                    <p>La Resolución MTEYSS 649/2022 dispone que el valor de la suma fija en concepto de FFEP se
                        incrementará mensualmente  para contratos del régimen general, según la variación de la
                        remuneración imponible promedio de las personas trabajadoras estables (ripte) - índice no
                        decreciente- y también dispone que el Artículo 2° de la Resolución MTEYSS N° 467,
                        del 10 de agosto de 2021, será de aplicación exclusivamente para empleadores/as de régimen
                        especial de casas particulares donde será de $278,00.- en los periodos del 07/2023 al 09/2023
                        bajo la <strong>Disposición 7/2023 SRT</strong>, siguiendo con el criterio de actualización mensual y/o trimestral.

                        <p />
                        Sin más saludamos a Ud. atentamente, quedando a disposición para cualquier consulta o inquietud.</p>
                    <p />

                    <div>
                        <strong>Pasos a seguir para modificar la suma fija FFEP dentro del F931 – AFIP</strong>
                        <ul>
                            <li>Ingresar a AFIP con CUIT y Clave fiscal.</li>
                            <li> <strong>Servicio:</strong> Declaración en Línea.</li>
                        </ul>
                        <div style={{ 'text-align-last': 'center', zoom: '80%' }}>
                            <p>
                                <img src={Img230815} />
                            </p>
                        </div>
                    </div>

                    <p /><p /><p /><p /><p />
                </div>

                {/*------------------------------------------*/}

                <div style={{ padding: '6% 0% 12% 0%', borderBottom: '3px solid #F8A700' }}>
                    <h5 style={{ color: 'white', backgroundColor: '#F8A700', width: 'fit-content' }}>
                        24 Julio 2023
                    </h5>

                    <h5 style={{ color: 'white', backgroundColor: '#F8A700' }}>
                        ACTUALIZACIÓN DEL FONDO FIDUCIARIO DE ENFERMEDADES PROFESIONALES (FFEP)<br />
                    </h5><p />
                    <br />
                    <p />

                    <p>

                        Le informamos que conforme lo establecido por la Resolución MTEYSS 6 9/2022 Disposición
                        SRT 7/2023 a partir del 01/08/2023, período AFIP a declarar 7/2023, el nuevo valor del
                        FFEP será de $278.00.- (DOSCIENTOS SETENTA Y OCHO), por cada trabajador conjuntamente
                        con la alícuota vigente de su contrato de Riesgos del Trabajo.


                    </p><p />
                    <p>La Resolución MTEYSS 649/2022 dispone que el valor de la suma fija en concepto de FFEP se
                        incrementará mensualmente  para contratos del régimen general, según la variación de la
                        remuneración imponible promedio de las personas trabajadoras estables (ripte) -
                        índice no decreciente- y también dispone que el Artículo 2° de la Resolución MTEYSS
                        N° 467, del 10 de agosto de 2021, será de aplicación exclusivamente para
                        empleadores/as de régimen especial de casas particulares donde será de $278,00.-
                        en los periodos del 04/2023 al 06/2023 bajo la <strong>Disposición 4/2023 SRT</strong>,
                        siguiendo con el criterio de actualización mensual y/o trimestral.

                        <p />
                        Sin más saludamos a Ud. atentamente, quedando a disposición para cualquier consulta o inquietud.</p>
                    <p />

                    <div>
                        <strong>Pasos a seguir para modificar la suma fija FFEP dentro del F931 – AFIP</strong>
                        <ul>
                            <li>Ingresar a AFIP con CUIT y Clave fiscal.</li>
                            <li> <strong>Servicio:</strong> Declaración en Línea.</li>
                        </ul>
                        <div style={{ 'text-align-last': 'center', zoom: '80%' }}>
                            <p>
                                <img src={Img230724} />
                            </p>
                        </div>
                    </div>

                    <p /><p /><p /><p /><p />
                </div>

                {/*------------------------------------------*/}

                <div style={{ padding: '6% 0% 12% 0%', borderBottom: '3px solid #F8A700' }}>
                    <h5 style={{ color: 'white', backgroundColor: '#F8A700', width: 'fit-content' }}>
                        22 Junio 2023
                    </h5>

                    <h5 style={{ color: 'white', backgroundColor: '#F8A700' }}>
                        ACTUALIZACIÓN DEL FONDO FIDUCIARIO DE ENFERMEDADES PROFESIONALES (FFEP)<br />
                    </h5><p />
                    <br />
                    <p />

                    <p>

                        Le informamos que conforme lo establecido por la Resolución MTEYSS 649/2022 Disposición
                        SRT 6/2023 a partir del 01/07/2023, período AFIP a declarar 06/2023, el nuevo valor del FFEP
                        será de $262.00.- (DOSCIENTOS SESENTA Y DOS), por cada trabajador conjuntamente con la
                        alícuota vigente de su contrato de Riesgos del Trabajo.

                    </p><p />
                    <p>La Resolución MTEYSS 649/2022 dispone que el valor de la suma fija en concepto de FFEP se
                        incrementará mensualmente para contratos del régimen general, según la variación de la
                        remuneración imponible promedio de las personas trabajadoras estables (ripte) - índice no
                        decreciente- y también dispone que el Artículo 2° de la Resolución MTEYSS N° 467, del 10 de
                        agosto de 2021, será de aplicación exclusivamente para empleadores/as de régimen especial
                        de casas particulares donde será de $217,00.- en los periodos del 04/2023 al 06/2023 bajo la
                        Disposición 4/2023 SRT, siguiendo con el criterio de actualización mensual y/o trimestral.
                        <p />
                        Sin más saludamos a Ud. atentamente, quedando a disposición para cualquier consulta o
                        inquietud.</p>
                    <p />

                    <div>
                        <strong>Pasos a seguir para modificar la suma fija FFEP dentro del F931 – AFIP</strong>
                        <ul>
                            <li>Ingresar a AFIP con CUIT y Clave fiscal.</li>
                            <li> <strong>Servicio:</strong> Declaración en Línea.</li>
                        </ul>
                        <div style={{ 'text-align-last': 'center', zoom: '80%' }}>
                            <p>
                                <img src={Img230622} />
                            </p>
                        </div>
                    </div>

                    <p /><p /><p /><p /><p />
                </div>

                {/*------------------------------------------*/}

                <div style={{ padding: '6% 0% 12% 0%', borderBottom: '3px solid #F8A700' }}>
                    <h5 style={{ color: 'white', backgroundColor: '#F8A700', width: 'fit-content' }}>
                        16 Mayo 2023
                    </h5>

                    <h5 style={{ color: 'white', backgroundColor: '#F8A700' }}>
                        ACTUALIZACIÓN DEL FONDO FIDUCIARIO DE ENFERMEDADES PROFESIONALES (FFEP)<br />
                    </h5><p />
                    <br />
                    <p />

                    <p>

                        Le informamos que conforme lo establecido por la Resolución MTEYSS 649/2022 Disposición
                        SRT 5/2023 a partir del 01/06/2023, período AFIP a declarar 05/2023, el nuevo valor del FFEP
                        será de $238.00.- (DOSCIENTOS TRENTA Y OCHO), por cada trabajador conjuntamente con la
                        alícuota vigente de su contrato de Riesgos del Trabajo.

                    </p><p />
                    <p>La Resolución MTEYSS 649/2022 dispone que el valor de la suma fija en concepto de FFEP se
                        incrementará mensualmente para contratos del régimen general, según la variación de la
                        remuneración imponible promedio de las personas trabajadoras estables (ripte) - índice no
                        decreciente- y también dispone que el Artículo 2° de la Resolución MTEYSS N° 467, del 10 de
                        agosto de 2021, será de aplicación exclusivamente para empleadores/as de régimen especial
                        de casas particulares donde será de $217,00.- en los periodos del 04/2023 al 06/2023 bajo la
                        Disposición 4/2023 SRT, siguiendo con el criterio de actualización mensual y/o trimestral.
                        Sin más saludamos a Ud. atentamente, quedando a disposición para cualquier consulta o
                        inquietud.</p>
                    <p />

                    <div>
                        <strong>Pasos a seguir para modificar la suma fija FFEP dentro del F931 – AFIP</strong>
                        <ul>
                            <li>Ingresar a AFIP con CUIT y Clave fiscal.</li>
                            <li> <strong>Servicio:</strong> Declaración en Línea.</li>
                        </ul>
                        <div style={{ 'text-align-last': 'center', zoom: '80%' }}>
                            <p>
                                <img src={Img230516} />
                            </p>
                        </div>
                    </div>

                    <p /><p /><p /><p /><p />
                </div>

                {/*------------------------------------------*/}

                <div style={{ padding: '6% 0% 12% 0%', borderBottom: '3px solid #F8A700' }}>
                    <h5 style={{ color: 'white', backgroundColor: '#F8A700', width: 'fit-content' }}>
                        02 Mayo 2023
                    </h5>

                    <h5 style={{ color: 'white', backgroundColor: '#F8A700' }}>
                        ACTUALIZACIÓN DEL FONDO FIDUCIARIO DE ENFERMEDADES PROFESIONALES (FFEP)<br />
                    </h5><p />
                    <br />
                    <p />

                    <p>

                        Le informamos que conforme lo establecido por la Resolución MTEYSS 649/2022 Disposición
                        SRT 4/2023 a partir del 01/05/2023, período AFIP a declarar 04/2023, el nuevo valor del FFEP
                        será de $217.00.- (DOSCIENTOS DIECISIETE), por cada trabajador conjuntamente con la alícuota vigente
                        de su contrato de Riesgos del Trabajo.

                    </p><p />
                    <p>La Resolución MTEYSS 649/2022 dispone que el valor de la suma fija en concepto de FFEP se
                        incrementará mensualmente para contratos del régimen general, según la variación de la
                        remuneración imponible promedio de las personas trabajadoras estables (ripte) - índice no
                        decreciente- y también dispone que el Artículo 2° de la Resolución MTEYSS N° 467, del 10 de
                        agosto de 2021, será de aplicación exclusivamente para empleadores/as de régimen especial
                        de casas particulares donde será de $217,00.- en los periodos del 04/2023 al 06/2023 bajo la
                        Disposición 4/2023 SRT, siguiendo con el criterio de actualización mensual y/o trimestral.
                        Sin más saludamos a Ud. atentamente, quedando a disposición para cualquier consulta o
                        inquietud.</p>
                    <p />

                    <div>
                        <strong>Pasos a seguir para modificar la suma fija FFEP dentro del F931 – AFIP</strong>
                        <ul>
                            <li>Ingresar a AFIP con CUIT y Clave fiscal.</li>
                            <li> <strong>Servicio:</strong> Declaración en Línea.</li>
                        </ul>
                        <div style={{ 'text-align-last': 'center', zoom: '80%' }}>
                            <p>
                                <img src={Img230502} />
                            </p>
                        </div>
                    </div>

                    <p /><p /><p /><p /><p />
                </div>

                {/*------------------------------------------*/}

                <div style={{ padding: '6% 0% 12% 0%', borderBottom: '3px solid #F8A700' }}>
                    <h5 style={{ color: 'white', backgroundColor: '#F8A700', width: 'fit-content' }}>
                        16 Marzo 2023
                    </h5>

                    <h5 style={{ color: 'white', backgroundColor: '#F8A700' }}>
                        ACTUALIZACIÓN DEL FONDO FIDUCIARIO DE ENFERMEDADES PROFESIONALES (FFEP)<br />
                    </h5><p />
                    <br />
                    <p />

                    <p>

                        Le informamos que conforme lo establecido por la Resolución MTEYSS 649/2022 Disposición
                        SRT 3/2023 a partir del 01/04/2023, período AFIP a declarar 03/2023, el nuevo valor del FFEP
                        será de $200.00.- (DOSCIENTOS), por cada trabajador conjuntamente con la alícuota vigente
                        de su contrato de Riesgos del Trabajo.

                    </p><p />
                    <p>La Resolución MTEYSS 649/2022 dispone que el valor de la suma fija en concepto de FFEP se
                        incrementará mensualmente para contratos del régimen general, según la variación de la
                        remuneración imponible promedio de las personas trabajadoras estables (ripte) - índice no
                        decreciente- y también dispone que el Artículo 2° de la Resolución MTEYSS N° 467, del 10 de
                        agosto de 2021, será de aplicación exclusivamente para empleadores/as de régimen especial
                        de casas particulares donde se mantiene en $183.00.-, siguiendo con el criterio de
                        actualización trimestral.
                        Sin más saludamos a Ud. atentamente, quedando a disposición para cualquier consulta o
                        inquietud.</p>
                    <p />

                    <div>
                        <strong>Pasos a seguir para modificar la suma fija FFEP dentro del F931 – AFIP</strong>
                        <ul>
                            <li>Ingresar a AFIP con CUIT y Clave fiscal.</li>
                            <li> <strong>Servicio:</strong> Declaración en Línea.</li>
                        </ul>
                        <div style={{ 'text-align-last': 'center', zoom: '80%' }}>
                            <p>
                                <img src={Img230316} />
                            </p>
                        </div>
                    </div>

                    <p /><p /><p /><p /><p />
                </div>

                {/*------------------------------------------*/}


                <div style={{ padding: '6% 0% 12% 0%', borderBottom: '3px solid #F8A700' }}>
                    <h5 style={{ color: 'white', backgroundColor: '#F8A700', width: 'fit-content' }}>
                        24 Febrero 2023
                    </h5>

                    <h5 style={{ color: 'white', backgroundColor: '#F8A700' }}>
                        ACTUALIZACIÓN DEL FONDO FIDUCIARIO DE ENFERMEDADES PROFESIONALES (FFEP)<br />
                    </h5><p />
                    <br />
                    <p />

                    <p>

                        Le informamos que conforme lo establecido por la Resolución MTEYSS 649/2022 Disposición
                        SRT 2/2023 a partir del 01/03/2023, período AFIP a declarar 02/2023, el nuevo valor del FFEP
                        será de $193.00.- (CIENTO NOVENTA Y TRES), por cada trabajador conjuntamente con la
                        alícuota vigente de su contrato de Riesgos del Trabajo.

                    </p><p />
                    <p>La Resolución MTEYSS 649/2022 dispone que el valor de la suma fija en concepto de FFEP se
                        incrementará mensualmente para contratos del régimen general, según la variación de la
                        remuneración imponible promedio de las personas trabajadoras estables (ripte) - índice no
                        decreciente- y también dispone que el Artículo 2° de la Resolución MTEYSS N° 467, del 10 de
                        agosto de 2021, será de aplicación exclusivamente para empleadores/as de régimen especial
                        de casas particulares donde se mantiene en $183.00.-, siguiendo con el criterio de
                        actualización trimestral.
                        Sin más saludamos a Ud. atentamente, quedando a disposición para cualquier consulta o
                        inquietud.</p>
                    <p />

                    <div>
                        <strong>Pasos a seguir para modificar la suma fija FFEP dentro del F931 – AFIP</strong>
                        <ul>
                            <li>Ingresar a AFIP con CUIT y Clave fiscal.</li>
                            <li> <strong>Servicio:</strong> Declaración en Línea.</li>
                        </ul>
                        <div style={{ 'text-align-last': 'center', zoom: '80%' }}>
                            <p>
                                <img src={Img230224} />
                            </p>
                        </div>
                    </div>

                    <p /><p /><p /><p /><p />
                </div>

                {/*------------------------------------------*/}


                <div style={{ padding: '6% 0% 12% 0%', borderBottom: '3px solid #F8A700' }}>
                    <h5 style={{ color: 'white', backgroundColor: '#F8A700', width: 'fit-content' }}>
                        25 Enero 2023
                    </h5>

                    <h5 style={{ color: 'white', backgroundColor: '#F8A700' }}>
                        ACTUALIZACIÓN DEL FONDO FIDUCIARIO DE ENFERMEDADES PROFESIONALES (FFEP)<br />
                    </h5><p />
                    <br />
                    <p />

                    <p>

                        Le informamos que conforme lo establecido por la Resolución MTEYSS 649/2022 Disposición
                        SRT 1/2023 a partir del 01/02/2023, período AFIP a declarar 01/2023, el nuevo valor del FFEP
                        será de $183.00.- (CIENTO OCHENTA Y TRES), por cada trabajador conjuntamente con la
                        alícuota vigente de su contrato de Riesgos del Trabajo.

                    </p><p />
                    <p>La Resolución MTEYSS 649/2022 dispone que el valor de la suma fija en concepto de FFEP se
                        incrementará mensualmente para contratos del régimen general, según la variación de la
                        remuneración imponible promedio de las personas trabajadoras estables (ripte) - índice no
                        decreciente- y también dispone que el Artículo 2° de la Resolución MTEYSS N° 467, del 10 de
                        agosto de 2021, será de aplicación exclusivamente para empleadores/as de régimen especial
                        de casas particulares.
                        Sin más saludamos a Ud. atentamente, quedando a disposición para cualquier consulta o
                        inquietud.</p>
                    <p />

                    <div>
                        <strong>Pasos a seguir para modificar la suma fija FFEP dentro del F931 – AFIP</strong>
                        <ul>
                            <li>Ingresar a AFIP con CUIT y Clave fiscal.</li>
                            <li> <strong>Servicio:</strong> Declaración en Línea.</li>
                        </ul>
                        <div style={{ 'text-align-last': 'center', zoom: '80%' }}>
                            <p>
                                <img src={Img230127} />
                            </p>
                        </div>
                    </div>

                    <p /><p /><p /><p /><p />
                </div>

                {/*------------------------------------------*/}


                <div style={{ padding: '6% 0% 12% 0%', borderBottom: '3px solid #F8A700' }}>
                    <h5 style={{ color: 'white', backgroundColor: '#F8A700', width: 'fit-content' }}>
                        28 Diciembre 2022
                    </h5>

                    <h5 style={{ color: 'white', backgroundColor: '#F8A700' }}>
                        ACTUALIZACIÓN DEL FONDO FIDUCIARIO DE ENFERMEDADES PROFESIONALES (FFEP)<br />
                    </h5><p />
                    <br />
                    <p />

                    <p>
                        Le informamos que conforme lo establecido por la Resolución MTEYSS 649/2022 Disposición
                        SRT 8/2022 a partir del 01/01/2023, período AFIP a declarar 12/2022, el nuevo valor del FFEP
                        será de $173.00.- (CIENTO SETENTA Y TRES), por cada trabajador conjuntamente con la
                        alícuota vigente de su contrato de Riesgos del Trabajo.

                    </p><p />
                    <p>La Resolución MTEYSS 649/2022 dispone que el valor de la suma fija en concepto de FFEP se
                        incrementará mensualmente para contratos del régimen general, según la variación de la
                        remuneración imponible promedio de las personas trabajadoras estables (ripte) - índice no
                        decreciente- y también dispone que el Artículo 2° de la Resolución MTEYSS N° 467, del 10 de
                        agosto de 2021, será de aplicación exclusivamente para empleadores/as de régimen especial
                        de casas particulares donde se mantiene en $155.00.-, siguiendo con el criterio de
                        actualización trimestral.
                        Sin más saludamos a Ud. atentamente, quedando a disposición para cualquier consulta o
                        inquietud</p>
                    <p />



                    <div>
                        <strong>Pasos a seguir para modificar la suma fija FFEP dentro del F931 – AFIP</strong>
                        <ul>
                            <li>Ingresar a AFIP con CUIT y Clave fiscal.</li>
                            <li> <strong>Servicio:</strong> Declaración en Línea.</li>
                        </ul>
                        <div style={{ 'text-align-last': 'center', zoom: '80%' }}>
                            <p>
                                <img src={Img221228} />
                            </p>
                        </div>
                    </div>

                    <p /><p /><p /><p /><p />
                </div>

                {/*------------------------------------------*/}

                <div style={{ padding: '6% 0% 12% 0%', borderBottom: '3px solid #F8A700' }}>
                    <h5 style={{ color: 'white', backgroundColor: '#F8A700', width: 'fit-content' }}>
                        25 Noviembre 2022
                    </h5>

                    <h5 style={{ color: 'white', backgroundColor: '#F8A700' }}>
                        ACTUALIZACIÓN DEL FONDO FIDUCIARIO DE ENFERMEDADES PROFESIONALES (FFEP)<br />
                    </h5><p />
                    <br />
                    <p />

                    <p>
                        Le informamos que conforme lo establecido por la Resolución MTEYSS 649/2022 Disposición
                        SRT 7/2022 a partir del 01/12/2022, período AFIP a declarar 11/2022, el nuevo valor del FFEP
                        será de $164.00.- (CIENTO SESENTA Y CUATRO), por cada trabajador conjuntamente con la
                        alícuota vigente de su contrato de Riesgos del Trabajo.

                    </p><p />
                    <p>La Resolución MTEYSS 649/2022 dispone que el valor de la suma fija en concepto de FFEP se
                        incrementará mensualmente para contratos del régimen general, según la variación de la
                        remuneración imponible promedio de las personas trabajadoras estables (ripte) - índice no
                        decreciente- y también dispone que el Artículo 2° de la Resolución MTEYSS N° 467, del 10 de
                        agosto de 2021, será de aplicación exclusivamente para empleadores/as de régimen especial
                        de casas particulares donde se mantiene en $155.00.-, siguiendo con el criterio de
                        actualización trimestral.
                        Sin más saludamos a Ud. atentamente, quedando a disposición para cualquier consulta o
                        inquietud</p>
                    <p />



                    <div>
                        <strong>Pasos a seguir para modificar la suma fija FFEP dentro del F931 – AFIP</strong>
                        <ul>
                            <li>Ingresar a AFIP con CUIT y Clave fiscal.</li>
                            <li> <strong>Servicio:</strong> Declaración en Línea.</li>
                        </ul>
                        <div style={{ 'text-align-last': 'center', zoom: '80%' }}>
                            <p>
                                <img src={Img221125} />
                            </p>
                        </div>
                    </div>




                    <p /><p /><p /><p /><p />
                </div>

                {/*------------------------------------------*/}

                <div style={{ padding: '6% 0% 12% 0%', borderBottom: '3px solid #F8A700' }}>
                    <h5 style={{ color: 'white', backgroundColor: '#F8A700', width: 'fit-content' }}>
                        4 Noviembre 2022
                    </h5>

                    <h5 style={{ color: 'white', backgroundColor: '#F8A700' }}>
                        ACTUALIZACIÓN DEL FONDO FIDUCIARIO DE ENFERMEDADES PROFESIONALES (FFEP)<br />
                    </h5><p />
                    <br />
                    <p />

                    <p>
                        Le informamos que conforme lo establecido por la Resolución MTEYSS 649/2022 Disposición
                        SRT 6/2022 a partir del 01/11/2022, período AFIP a declarar 10/2022, el nuevo valor del FFEP
                        será de $155.00.- CIENTO CINCUENTA Y CINCO, por cada trabajador conjuntamente con la
                        alícuota vigente de su contrato de Riesgos del Trabajo.

                    </p><p />
                    <p>La Resolución MTEYSS 649/2022 dispone que el valor de la suma fija en concepto de FFEP se
                        incrementará mensualmente para contratos del régimen general, según la variación de la
                        remuneración imponible promedio de las personas trabajadoras estables (ripte) - índice no
                        decreciente- y también dispone que el Artículo 2° de la Resolución MTEYSS N° 467, del 10 de
                        agosto de 2021, será de aplicación exclusivamente para empleadores/as de régimen especial
                        de casas particulares.</p>
                    <p />



                    <div>
                        <strong>Pasos a seguir para modificar la suma fija FFEP dentro del F931 – AFIP</strong>
                        <ul>
                            <li>Ingresar a AFIP con CUIT y Clave fiscal.</li>
                            <li> <strong>Servicio:</strong> Declaración en Línea.</li>
                        </ul>
                        <div style={{ 'text-align-last': 'center', zoom: '70%' }}>
                            <p>
                                <img src={Img221104} />
                            </p>
                        </div>
                    </div>




                    <p /><p /><p /><p /><p />
                </div>

                {/*------------------------------------------*/}

                <div style={{ padding: '6% 0% 12% 0%', borderBottom: '3px solid #F8A700' }}>
                    <h5 style={{ color: 'white', backgroundColor: '#F8A700', width: 'fit-content' }}>
                        22 Septiembre 2022
                    </h5>

                    <h5 style={{ color: 'white', backgroundColor: '#F8A700' }}>
                        ACTUALIZACIÓN DEL FONDO FIDUCIARIO DE ENFERMEDADES PROFESIONALES (FFEP)<br />
                    </h5><p />
                    <br />
                    <p />

                    <p>
                        Le informamos que de acuerdo a la Disposición SRT 5/2022
                        {/*<a href="https://www.boletinoficial.gob.ar/detalleAviso/primera/266805/20220719" style={{color:'blue','text-decoration': 'underline' }} target="_blank"> Disposición SRT 4/2022</a>*/}

                        a partir del 01/10/2022, período AFIP a declarar 09/2022, el nuevo valor del FFEP será de, PESOS CIENTO CUARENTA Y NUEVE ($149,00.-), por cada trabajador conjuntamente con la alícuota vigente de su contrato de Riesgos del Trabajo.
                    </p><p />
                    <p>La Resolución MTEYSS 649/2022 dispone que el valor de la suma fija en concepto de FFEP se incrementará mensualmente para contratos del régimen general, según la variación de la remuneración imponible promedio de las personas trabajadoras estables (RIPTE) - índice no decreciente- y también dispone que el Artículo 2° de la Resolución MTEYSS N° 467, del 10 de agosto de 2021, será de aplicación exclusivamente para empleadores/as de régimen especial de casas particulares.</p>
                    <p />
                    <div>
                        <a href="#">
                            <Link to={"Download/FFEP/FFEP220922.pdf"} target="_blank" download>
                                <Icon style={{ float: "right" }} fill="#F8A700" width={25} />
                            </Link>
                        </a>
                    </div>
                    <p /><p /><p /><p /><p />
                </div>

                {/*------------------------------------------*/}


                <div style={{ padding: '6% 0% 12% 0%', borderBottom: '3px solid #F8A700' }}>
                    <h5 style={{ color: 'white', backgroundColor: '#F8A700', width: 'fit-content' }}>
                        26 Agosto 2022
                    </h5>

                    <h5 style={{ color: 'white', backgroundColor: '#F8A700' }}>
                        ACTUALIZACIÓN DEL FONDO FIDUCIARIO DE ENFERMEDADES PROFESIONALES (FFEP)<br />
                    </h5><p />
                    <br />
                    <p />

                    <p>
                        Le informamos que de acuerdo a la Disposición SRT 4/2022
                        {/*<a href="https://www.boletinoficial.gob.ar/detalleAviso/primera/266805/20220719" style={{color:'blue','text-decoration': 'underline' }} target="_blank"> Disposición SRT 4/2022</a>*/}

                        , a partir del 01/09/2022, período AFIP a declarar 08/2022, el nuevo valor del FFEP será de, PESOS CIENTO CUARENTA Y UNO- $141,00.-), por cada trabajador conjuntamente con la alícuota vigente de su contrato de Riesgos del Trabajo.
                    </p><p />

                    <p>La Resolución MTEYSS 649/2022 dispone que el valor de la suma fija en concepto de FFEP se incrementará mensualmente para contratos del régimen general, según la variación de la remuneración imponible promedio de las personas trabajadoras estables (ripte) - índice no decreciente- y también dispone que el Artículo 2° de la Resolución MTEYSS N° 467, del 10 de agosto de 2021, será de aplicación exclusivamente para empleadores/as de régimen especial de casas particulares.</p>
                    <p /><p /><p /><p /><p /><p />
                </div>

                {/*------------------------------------------*/}


                {/* ACA VA LA NOVEDAD DE CESAR GOMEZ */}


                <div style={{ padding: '6% 0% 12% 0%', borderBottom: '3px solid #F8A700' }}>
                    <h5 style={{ color: 'white', backgroundColor: '#F8A700', width: 'fit-content' }}>
                        25 Julio 2022
                    </h5>

                    <h5 style={{ color: 'white', backgroundColor: '#F8A700' }}>
                        ACTUALIZACIÓN DEL FONDO FIDUCIARIO DE ENFERMEDADES PROFESIONALES (FFEP)<br />
                    </h5><p />
                    <br />
                    <p />

                    <p>
                        Le informamos que de acuerdo con la
                        <a href="https://www.boletinoficial.gob.ar/detalleAviso/primera/266805/20220719" style={{ color: 'blue', 'text-decoration': 'underline' }} target="_blank"> Disposición SRT 3/2022</a>
                        , a partir de de agosto del 2022, el nuevo valor del FFEP será de PESOS CIENTO TREINTA Y TRES ($133)  por cada trabajador conjuntamente con la alícuota vigente de su contrato de Riesgos del Trabajo para el devengado del mes de julio de 2022.
                    </p><p />

                    <p>Recordamos que la Resolución 467/2021 del Ministerio de Trabajo, Empleo y Seguridad Social dispone que el valor de la suma fija en concepto de FFEP se incrementará trimestralmente según la remuneración imponible promedio de los trabajadores estables (RIPTE) – Índice No Decreciente- y establece que la SRT es el organismo encargado de la publicación trimestral del valor de la suma fija actualizada.</p>
                    <p /><p /><p /><p /><p /><p />
                </div>

                {/*------------------------------------------*/}

                <div style={{ padding: '6% 0% 12% 0%', borderBottom: '3px solid #F8A700' }}>
                    <h5 style={{ color: 'white', backgroundColor: '#F8A700', width: 'fit-content' }}>
                        29 Junio 2022
                    </h5>

                    <h5 style={{ color: 'white', backgroundColor: '#F8A700' }}>
                        ACTUALIZACIÓN DEL FONDO FIDUCIARIO DE ENFERMEDADES PROFESIONALES (FFEP)<br />
                    </h5><p />
                    <br />
                    <p />

                    <p>
                        Le informamos que de acuerdo con la
                        <a href="http://servicios.infoleg.gob.ar/infolegInternet/anexos/40000-44999/44300/texact.htm" style={{ color: 'blue', 'text-decoration': 'underline' }} target="_blank"> Resolución MTEYSS 649/2022</a>
                        , a partir del 01/07/2022, período AFIP a declarar 06/2022, el nuevo valor del FFEP será de PESOS CIENTO VEINTE Y SIETE CON SESENTA Y CINCO CENTAVOS ($127,65), por cada trabajador conjuntamente con la alícuota vigente de su contrato de Riesgos del Trabajo.
                    </p><p />

                    <p>La Resolución MTEYSS 649/2022 dispone que el valor de la suma fija en concepto de FFEP se incrementará mensualmente para contratos del régimen general, según la variación de la remuneración imponible promedio de las personas trabajadoras estables (ripte) - índice no decreciente- y también dispone que el Artículo 2° de la Resolución MTEYSS N° 467, del 10 de agosto de 2021, será de aplicación exclusivamente para empleadores/as de régimen especial de casas particulares.</p>
                    <p /><p /><p /><p /><p /><p />
                </div>


                {/*------------------------------------------*/}



                <div style={{ padding: '6% 0% 12% 0%', borderBottom: '3px solid #F8A700' }}>
                    <h5 style={{ color: 'white', backgroundColor: '#F8A700', width: 'fit-content' }}>
                        28 Abril 2022
                    </h5>

                    <h5 style={{ color: 'white', backgroundColor: '#F8A700' }}>
                        ACTUALIZACIÓN DEL FONDO FIDUCIARIO DE ENFERMEDADES PROFESIONALES (FFEP)<br />
                    </h5><p />
                    <br />
                    <p />

                    <p>
                        Te informamos que de acuerdo con la
                        <a href="https://www.boletinoficial.gob.ar/detalleAviso/primera/261545/20220428" style={{ color: 'blue', 'text-decoration': 'underline' }} target="_blank"> Disposición SRT 2/2022 </a>
                        , a partir del primero de mayo del 2022, período AFIP a declarar 04/2022, el nuevo valor del FFEP será de PESOS CIENTO ONCE CON SETENTA Y CINCO CENTAVOS ($111,75), por cada trabajador conjuntamente con la alícuota vigente de su contrato de Riesgos del Trabajo.
                    </p><p />

                    <p>Recordamos que la Resolución 467/2021 del Ministerio de Trabajo, Empleo y Seguridad Social  dispone que el valor de la suma fija en concepto de FFEP se incrementará trimestralmente según la remuneración imponible promedio de los trabajadores estables (RIPTE) – Índice No Decreciente- y establece que la SRT es el organismo encargado de la publicación trimestral del valor de la suma fija actualizada.</p>
                    <p /><p /><p /><p /><p /><p />
                </div>


                {/*------------------------------------------*/}

                <div style={{ padding: '6% 0% 12% 0%', borderBottom: '3px solid #F8A700' }}>
                    <h5 style={{ color: 'white', backgroundColor: '#F8A700', width: 'fit-content' }}>
                        5 Enero 2022
                    </h5>

                    <h5 style={{ color: 'white', backgroundColor: '#F8A700' }}>
                        ACTUALIZACIÓN DEL FONDO FIDUCIARIO DE ENFERMEDADES PROFESIONALES (FFEP)<br />
                    </h5><p />
                    <h6 style={{ display: 'inline-flex', borderBottom: '2px solid #F8A700' }}>Nuevas medidas en el marco del COVID-19</h6>

                    <br />
                    <p />

                    <p>
                        Te informamos que el Ministerio de Trabajo, Empleo y Seguridad Social de la Nación emitió una nueva disposición, SRT 794/2021 , que a partir de febrero 2022, periodo AFIP a declarar 01/2022, el nuevo valor del FFEP que será de un valor de PESOS CIEN ($100,00) por cada trabajador con la alícuota vigente de su contrato de Riesgos del Trabajo.por cada trabajador conjuntamente con la alícuota vigente de su contrato de Riesgos del Trabajo.
                        <br />
                    </p><p />

                    <p>La Resolución determina adicionalmente que el valor de la suma fija a abonar por cada persona trabajadora en concepto de FFEP, se incrementará trimestralmente según la variación de la Remuneración Imponible Promedio de los Trabajadores Estables (RIPTE) – índice no decreciente. La SRT es el organismo encargado de la publicación trimestral del valor de la suma fija actualizada.</p>
                    <p /><p /><p /><p /><p /><p />
                </div>



                {/*------------------------------------------*/}

                <div style={{ padding: '6% 0% 12% 0%', borderBottom: '3px solid #F8A700' }}>

                    <h5 style={{ color: 'white', backgroundColor: '#F8A700', width: 'fit-content' }}>
                        26 Octubre 2021
                    </h5>

                    <h5 style={{ color: 'white', backgroundColor: '#F8A700' }}>
                        ACTUALIZACIÓN DEL FONDO FIDUCIARIO DE ENFERMEDADES PROFESIONALES (FFEP)<br />
                    </h5><p />

                    <h6 style={{ display: 'inline-flex', borderBottom: '2px solid #F8A700' }}>Nuevas medidas en el marco del COVID-19</h6>
                    <p>
                        {/*Te informamos que el Ministerio de Trabajo, Empleo y Seguridad Social de la Nación emitió una nueva  Resolución, la <a href="https://www.boletinoficial.gob.ar/detalleAviso/primera/247937/20210811" style={{color:'blue','text-decoration': 'underline' }} target="_blank"> N° 467/2021</a> que establece que a partir del 1° de septiembre de 2021, período AFIP a declarar 08/2021, el nuevo valor del FFEP será de un valor de PESOS CUARENTA Y CINCO CON SIETE CENTAVOS ($45,07).<br/>*/}
                        Te informamos que el Ministerio de Trabajo, Empleo y Seguridad Social de la Nación emitió una nueva disposición, SRT 2/2021,  que a partir del 01/11/2021, periodo AFIP a declarar 10/2021, el nuevo valor del FFEP que será de un valor de PESOS CUARENTA Y NUEVE CON NOVENTA Y OCHO CENTAVOS ($49,98).<br />
                    </p> <p /><p />

                    <p>
                        {/*La Resolución determina adicionalmente que el valor de la suma fija a abonar por cada persona trabajadora en concepto de FFEP, se incrementará trimestralmente según la variación de la Remuneración Imponible Promedio de los Trabajadores Estables (RIPTE) – índice no decreciente. La SRT es el organismo encargado de la publicación trimestral del valor de la suma fija actualizada.<br/>*/}
                        La Resolución determina adicionalmente que el valor de la suma fija a abonar por cada persona trabajadora en concepto de FFEP, se incrementará trimestralmente según la variación de la Remuneración Imponible Promedio de los Trabajadores Estables (RIPTE) – índice no decreciente. La SRT es el organismo encargado de la publicación trimestral del valor de la suma fija actualizada.<br />
                    </p> <p /><p />

                    {/*<p>
                Por este motivo, según el Organismo, corresponde adecuar el monto establecido en el artículo 5° del <a href="https://www.argentina.gob.ar/normativa/nacional/decreto-590-1997-44300/actualizacion" style={{color:'blue','text-decoration': 'underline' }} target="_blank"> Decreto N° 590/97</a> a un valor acorde a las circunstancias particulares descriptas anteriormente, que han derivado en una dinámica de imputación de costos prestacionales diferente respecto de aquella bajo la cual fuera concebido el FFEP.<br/>
                </p> <p/><p/> */}
                </div>
            </div>
        )
    }
}

export default FFEP
